import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const reviewNotesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAllReviewNotes: builder.query({
      query: ({ type, id }) =>
        (config.GetReviewNotes || "") + type + "&id=" + id,
      providesTags: ["ReviewNotes"],
    }),
    addReviewNotes: builder.mutation({
      query: (data) => ({
        url: config.AddReviewNotes || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ReviewNotes"],
    }),
  }),
});

export const {
  useLoadAllReviewNotesQuery,
  useLazyLoadAllReviewNotesQuery,
  useAddReviewNotesMutation,
} = reviewNotesApiSlice;
